import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import ModelContainer from "../../../Components/ModelContainer";

import Select from "../../../Components/Select";
import Input from "../../../Components/Input";
import DateInput from "../../../Components/DateInput";
import MultiSelect from "../../../Components/MultiSelect";

import { useForm, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../../Redux";
import DynamicModal from "../../../Components/DynamicModal";

const LaborPolicy = (params) => {
  const labourGeneralFormDefaultState = {};

  const labourGeneralFormSchema = yup.object({});

  const {
    register: labourGeneralFormRegister,
    formState: { errors: labourGeneralFormError },
    handleSubmit: labourGeneralFormSubmit,
    reset: labourGeneralFormReset,
    control,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(labourGeneralFormSchema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: labourGeneralFormDefaultState,
  });

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="row lbrSettingMs d-flex">
              <div className="col-md-12 modify">
                <div className="shadowclass mt-4 d-flex flex-wrap align-content-start">
                  <h4 className="event-alert w-100 mb-4">
                    General Labor Settings
                  </h4>
                  <div className="d-flex calc-height w-100 flex-wrap">
                    <div className="settings-left-content fixed-pos col-3">
                      <ul className="settingMenus">
                        <li id="AccDetail_li" className="active">
                          <a href="#_" id="AccDetail_dayTime_a">
                            Account <br /> Payroll
                          </a>
                        </li>
                        <li id="Address_li" className="">
                          <a href="#_" id="Address_dayTime_a">
                            SCHEDULING
                          </a>
                        </li>
                        <li id="FinSettings_li" className="">
                          <a href="#_" id="FinSettings_dayTime_a">
                            EMPLOYEE <br />
                            BENEFITS
                          </a>
                        </li>
                        <li id="FinSettings_li" className="">
                          <a href="#_" id="FinSettings_dayTime_a">
                            OTHER ADMIN
                          </a>
                        </li>
                      </ul>
                    </div>

                    <div className="settings-right-content scrolling col-9">
                      <div className="date-sec-scroll">
                        <div
                          id="AccDetail_dayTime_div"
                          className="row-fluid scroll-change full_div"
                          day_time="AccDetail"
                        >
                          <div className="form-secs">
                            <h4> Account Payroll</h4>

                            <ul class="ingredient-info edit-shift">
                              <Input
                                label={"First Day of Work Week"}
                                formRegister={labourGeneralFormRegister}
                                formError={labourGeneralFormError}
                                formKey="first_day_of_Week"
                              />
                              <Select
                                label={"Payroll Default Payment Account"}
                                formRegister={labourGeneralFormRegister}
                                formError={labourGeneralFormError}
                                formKey="payroll_account"
                                optionsArray={[]}
                                onChange={(e) => {}}
                              />

                              <Input
                                label={
                                  " Working Hours Equivalent for Full Day Leave (For OT Calculation)"
                                }
                                formRegister={labourGeneralFormRegister}
                                formError={labourGeneralFormError}
                                formKey="a"
                              />

                              <Select
                                label={
                                  "Specific Employee's Payroll Verification Required? (Group Only)"
                                }
                                formRegister={labourGeneralFormRegister}
                                formError={labourGeneralFormError}
                                formKey="a"
                                optionsArray={[]}
                                onChange={(e) => {}}
                              />

                              <MultiSelect
                                label={" Verifying Employee(s) (Group Only)"}
                                // localStateValue={linkedStation}
                                // setLocalStateMethod={setLinkedStation}
                                optionsArray={[]}
                                formRegister={labourGeneralFormRegister}
                                formError={labourGeneralFormError}
                                formFieldSetMethod={setValue}
                                getFieldValues={getValues}
                                formKey={"a"}
                                extraClass={"d-flex col-12 align-items-center"}
                                innerDivClass={"select-div input-group full-width"}
                              />

                              <li class="auto-hgt">
                                <div className="table-responsive">
                                  <table
                                    id="payroll_frequency"
                                    class="checklist-table remove-space aviTable"
                                    cellspacing="0"
                                    cellpadding="0"
                                    width="100%"
                                  >
                                    <thead>
                                      <tr>
                                        <th>Payroll Name / Frequency</th>
                                        <th>Interim Period Ending Date</th>
                                        <th>Final Period Ending Date</th>
                                        <th>Action</th>
                                      </tr>
                                    </thead>
                                    <tbody id="AddPayrollFrequencies">
                                      <tr>
                                        <td>
                                          <b>Monthly FT Payroll</b> <br />
                                          Monthly
                                        </td>
                                        <td></td>
                                        <td>22 of the Month</td>
                                        <td>
                                          <a
                                            href="#_"
                                            class="editFrequency circle_icon"
                                            val="123"
                                          >
                                            <i class="iconSprites edit-icon"></i>
                                          </a>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <div class="my-3">
                                  <a
                                    id="addFrequency"
                                    class="btn green-btn-revert add-plus"
                                    href="#_"
                                  >
                                    <i class="i-icon"> </i> Add Payroll
                                    Frequency
                                  </a>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>

                        <div
                          id="Address_dayTime_div"
                          className="row-fluid scroll-change full_div"
                          day_time="Address"
                        >
                          <div className="form-secs">
                            <h4> Scheduling </h4>
                            <ul class="ingredient-info edit-shift">
                              <Select
                                label={
                                  'Maximum weekly "Off" Days Allowed for Restorable Salaried Staff'
                                }
                                formRegister={labourGeneralFormRegister}
                                formError={labourGeneralFormError}
                                formKey="payroll_account"
                                optionsArray={[]}
                                onChange={(e) => {}}
                              />
                              <Select
                                label={"Total Shift Hours Nearest Rounding"}
                                formRegister={labourGeneralFormRegister}
                                formError={labourGeneralFormError}
                                formKey="payroll_account"
                                optionsArray={[]}
                                onChange={(e) => {}}
                              />
                              <Select
                                label={"Max Clock-In Early Allowed"}
                                formRegister={labourGeneralFormRegister}
                                formError={labourGeneralFormError}
                                formKey="payroll_account"
                                optionsArray={[]}
                                onChange={(e) => {}}
                              />
                              <Select
                                label={"Clock-In Tardy Grace Period"}
                                formRegister={labourGeneralFormRegister}
                                formError={labourGeneralFormError}
                                formKey="payroll_account"
                                optionsArray={[]}
                                onChange={(e) => {}}
                              />
                              <Select
                                label={"Clock-Out Early Grace Period"}
                                formRegister={labourGeneralFormRegister}
                                formError={labourGeneralFormError}
                                formKey="payroll_account"
                                optionsArray={[]}
                                onChange={(e) => {}}
                              />

                              <li class="time-section auto-hgt">
                                <div class="d-flex justify-cotent-between flex-wrap">
                                  <div class="col-md-6 col-12">
                                    <ul class="bullets-list scheduling_fields">
                                      <li>
                                        Max Early
                                        <br /> Clock-In
                                        <span class="time-duration arrow-right max_clock_in_early"></span>
                                      </li>
                                      <li class="active">
                                        Schedule <br /> Check-In
                                        <span class="time-duration arrow-left clock_in_tardy_grace_period"></span>
                                      </li>
                                      <li>
                                        Clock-In
                                        <br /> Grace Period
                                      </li>
                                    </ul>
                                  </div>
                                  <div class="col-md-6 align-right col-12">
                                    <ul class="bullets-list scheduling_fields">
                                      <li>
                                        Clock-Out
                                        <br /> Grace Period
                                        <span class="time-duration arrow-right clock_in_early_grace_period"></span>
                                      </li>
                                      <li>
                                        Scheduled
                                        <br /> Check-Out
                                        <span class="time-duration arrow-right shift_hours_rounding">
                                          <span>Down 15 Minutes</span>
                                        </span>
                                      </li>
                                      <li>
                                        Total
                                        <br /> Period
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>

                        <div
                          id="FinSettings_dayTime_div"
                          className="row-fluid scroll-change full_div"
                          day_time="FinSettings"
                        >
                          <div className="form-secs">
                            <h4> Employee Benefits</h4>
                            <ul class="ingredient-info edit-shift d-flex">
                              <Select
                                label={"Allow Staff Meals in POS"}
                                formRegister={labourGeneralFormRegister}
                                formError={labourGeneralFormError}
                                formKey="payroll_account"
                                optionsArray={[]}
                                onChange={(e) => {}}
                              />
                            </ul>
                          </div>
                        </div>

                        <div
                          id="FinSettings_dayTime_div"
                          className="row-fluid scroll-change full_div"
                          day_time="FinSettings"
                        >
                          <div className="form-secs">
                            <h4> Other Admin</h4>
                            <ul class="ingredient-info edit-shift">
                              <Select
                                label={"Appraisal Required for New Joiners?"}
                                formRegister={labourGeneralFormRegister}
                                formError={labourGeneralFormError}
                                formKey="payroll_account"
                                optionsArray={[]}
                                onChange={(e) => {}}
                              />
                              <Select
                                label={"Probation Period"}
                                formRegister={labourGeneralFormRegister}
                                formError={labourGeneralFormError}
                                formKey="payroll_account"
                                optionsArray={[]}
                                onChange={(e) => {}}
                              />
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mx-0">
              <div class="container px-0 d-flex col-12">
                <div class="btns col-4 d-flex justify-content-end py-4 col-12">
                  <button id="cancel" type="button">
                    Cancel
                  </button>
                  <button id="" type="Submit">
                    Save
                  </button>
                </div>
              </div>
            </div>

            <div className="accordion" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <h2 className="accordion-header" id="panelsStayOpen-headingOne">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseOne"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseOne"
                  >
                    <div className="col d-flex align-items-center">
                      <h4 className="event-alert p-0 mb-0">
                        Leave/Claim Rules
                      </h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingOne"
                >
                  <div className="row mx-0">
                    <div className="container px-0">
                      <div className="shadowclass mt-0">
                        <div className="row justify-content-between align-items-center mx-0">
                          <div className="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                            <div className="search-box mt-0">
                              <form type="GET">
                                <input
                                  type="text"
                                  placeholder="Search"
                                  name="keyword1"
                                />
                                <input type="submit" />
                              </form>
                            </div>
                          </div>
                          <div class="col-sm-7 col-12 align-right px-0">
                            <div class="field text-right">
                              <button
                                class="btn green-btn-revert add-plus addSp"
                                id="addCount"
                                type="button"
                              >
                                <i class="i-icon"> </i> Add Leave/Claim Rule
                              </button>
                              <button
                                class="btn bordered-btn open_lcr_template"
                                id="addCount"
                                type="button"
                              >
                                Add From Template
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className="table-responsive">
                          <table className="checklist-table remove-space inventory_table">
                            <thead>
                              <tr>
                                <th className="col-1">Rule Name &amp; Type</th>
                                <th class="col-2">Employment Status</th>
                                <th class="col-2">Function</th>
                                <th class="col-2">Category</th>
                                <th class="col-2">Employee Name</th>
                                <th class="col-2">Allotment Amount (Days)</th>
                                <th class="col-2">Accrual Type</th>
                                <th class="action-td">Actions</th>
                              </tr>
                            </thead>
                            <tbody></tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="panelsStayOpen-headingTwo">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseTwo"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseTwo"
                  >
                    <div className="col d-flex align-items-center">
                      <h4 className="event-alert p-0 mb-0">Overtime Rules</h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="panelsStayOpen-headingTwo"
                >
                  <div className="row mx-0">
                    <div className="container px-0">
                      <div className="shadowclass mt-0">
                        <div className="row justify-content-between align-items-center mx-0">
                          <div className="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                            <div className="search-box mt-0">
                              <form type="GET">
                                <input
                                  type="text"
                                  placeholder="Search"
                                  name="keyword1"
                                />
                                <input type="submit" />
                              </form>
                            </div>
                          </div>
                          <div class="col-sm-7 col-12 align-right px-0">
                            <div class="field text-right">
                              <button
                                class="btn green-btn-revert add-plus addSp"
                                id="addCount"
                                type="button"
                              >
                                <i class="i-icon"> </i> Add Overtime Rule
                              </button>
                              <button
                                class="btn bordered-btn open_lcr_template"
                                id="addCount"
                                type="button"
                              >
                                Add From Template
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className="table-responsive">
                          <table className="checklist-table remove-space inventory_table">
                            <thead>
                              <tr>
                                <th className="col-1">Rule Name &amp; Type</th>
                                <th class="col-2">Employment Status</th>
                                <th class="col-2">Function</th>
                                <th class="col-2">Category</th>
                                <th class="col-2">Employee Name</th>
                                <th class="col-2">Accrue After</th>
                                <th class="col-2">Multiplier</th>
                                <th class="action-td">Actions</th>
                              </tr>
                            </thead>
                            <tbody></tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModelContainer
        title={`Add Payroll Frequency`}
        open={false}
        closeModal={() => null}
        is_loading={false}
      >
        <fieldset class="">
          <ul class="form-list label-group">
            <li>
              <label for="PayrollFrequencyPayrollName" class="required">
                Payroll Name
              </label>
              <div class="input-wrap">
                <input
                  name="data[PayrollFrequency][payroll_name]"
                  class="required"
                  placeholder="Payroll Name"
                  maxlength="255"
                  type="text"
                  id="PayrollFrequencyPayrollName"
                />
              </div>
            </li>
            <li>
              <label class="required">Frequency</label>
              <div class="input-wrap select-div">
                <select
                  name="data[PayrollFrequency][payroll_frequency_id]"
                  class="payroll_frequency"
                  id="PayrollFrequencyPayrollFrequencyId"
                >
                  <option value="">Select Payroll Frequency</option>
                  <option value="1">Bi-Weekly</option>
                  <option value="2">Monthly</option>
                </select>
              </div>
            </li>
          </ul>
        </fieldset>
      </ModelContainer>

      <ModelContainer
        title={`Add Leave/Claim Rules`}
        open={false}
        closeModal={() => null}
        is_loading={false}
      >
        <fieldset class="">
          <ul class="form-list label-group">
            <li>
              <label for="LaborSettingRuleName" class="required">
                Rule Name
              </label>
              <div class="input-wrap">
                <input
                  name="data[LaborSetting][rule_name]"
                  class="required"
                  placeholder="Rule Name"
                  type="text"
                  id="LaborSettingRuleName"
                />
              </div>
            </li>
            <li>
              <label for="LaborSettingLeaveTypeId" class="required">
                Type
              </label>
              <div class="input-wrap select-div">
                <select
                  name="data[LaborSetting][leave_type_id]"
                  class="required leave_type"
                  id="LaborSettingLeaveTypeId"
                >
                  <option value="">Select Type</option>
                  <option value="1">Annual Leave</option>
                  <option value="2">Sick Leave</option>
                  <option value="3">Compassionate Leave</option>
                  <option value="4">Family Leave</option>
                  <option value="5">Paternity/Maternity Leave</option>
                  <option value="6">Medical Claims</option>
                  <option value="7">Birthday Leave</option>
                  <option value="8">No Pay Leave</option>
                  <option value="9">
                    In-Lieu Leave (Public Holiday with Expiry)
                  </option>
                  <option value="10">
                    In Lieu Leave (Public Holiday Earned)
                  </option>
                  <option value="11">Child Care Leave</option>
                  <option value="12">In Lieu (Year-Round)</option>
                  <option value="13">In Lieu leave (Manual with Expiry)</option>
                  <option value="14">Hospitalisation Leave</option>
                </select>
              </div>
            </li>
            <li>
              <label for="LaborSettingEmploymentStatusId" class="required">
                Employee Status
              </label>
              <div class="input-wrap select-div">
                <select
                  name="data[LaborSetting][employment_status_id]"
                  class="required getEmployees status_dd"
                  id="LaborSettingEmploymentStatusId"
                >
                  <option value="">Select Employment Status</option>
                  <option value="1">Full Time</option>
                  <option value="2">Part Time</option>
                  <option value="3">Contractor</option>
                  <option value="all">All</option>
                </select>
              </div>
            </li>
            <li>
              <label for="LaborSettingEmployeeFunctionId" class="required">
                Employee Function
              </label>
              <div class="input-wrap select-div">
                <select
                  name="data[LaborSetting][employee_function_id]"
                  class="required getEmployees function_dd"
                  id="LaborSettingEmployeeFunctionId"
                >
                  <option value="">Select Employee Function</option>
                  <option value="1">Management</option>
                  <option value="2">Host</option>
                  <option value="3">Kitchen</option>
                  <option value="4">Service</option>
                  <option value="5">Delivery</option>
                  <option value="all">All</option>
                </select>
              </div>
            </li>

            <li>
              <label for="LaborSettingEmployeeCategoryId" class="required">
                Employee Category
              </label>
              <div class="input-wrap select-div">
                <select
                  name="data[LaborSetting][employee_category_id]"
                  class="required getEmployees employee_category_id "
                  id="LaborSettingEmployeeCategoryId"
                >
                  <option value="">Select Employee Category</option>
                  <option value="1">New Category</option>
                  <option value="all">All Categories</option>
                </select>
              </div>
            </li>
            <li class="hide employee_category">
              <label for="LaborSettingEmployeeCategory" class="required">
                Employee Category
              </label>
              <div class="input-wrap">
                <input
                  name="data[LaborSetting][employee_category]"
                  class="required employee_category "
                  type="text"
                  id="LaborSettingEmployeeCategory"
                />
              </div>
            </li>
            <li>
              <label for="LaborSettingEmployeeSelect" class="required">
                Employee Select
              </label>
              <div class="input-wrap select-div">
                <div class="ms-parent">
                  <button type="button" class="ms-choice">
                    <span class="placeholder">Select Employees</span>
                    <div class=""></div>
                  </button>
                </div>
              </div>
            </li>
            <li>
              <label for="LaborSettingAllotmentAmount" class="required">
                Allotment Amount(Days)
              </label>
              <div class="input-wrap">
                <input
                  name="data[LaborSetting][allotment_amount]"
                  class="required number"
                  placeholder="Allotment Amount"
                  step="0.1"
                  autocomplete="off"
                  type="text"
                  id="LaborSettingAllotmentAmount"
                />
              </div>
            </li>
            <li>
              <label for="LaborSettingAccrualTypeId" class="required">
                Accrual Type
              </label>
              <div class="input-wrap select-div">
                <select
                  name="data[LaborSetting][accrual_type_id]"
                  class="required accrual_type"
                  id="LaborSettingAccrualTypeId"
                >
                  <option value="">Select Accrual Type</option>
                </select>
              </div>
            </li>
            <li class="birthexpired">
              <label for="LaborSettingBirthdayExpired" class="required">
                Expired
              </label>
              <div class="input-wrap">
                <input
                  name="data[LaborSetting][birthday_expired]"
                  class="required datepicker"
                  placeholder="Expired"
                  autocomplete="off"
                  type="text"
                  id="LaborSettingBirthdayExpired"
                />
              </div>
            </li>
            <li class="expiry_months">
              <label for="LaborSettingExpiryMonths" class="required">
                Expiry Months
              </label>
              <div class="input-wrap">
                <input
                  name="data[LaborSetting][expiry_months]"
                  class="required number"
                  placeholder="Enter expiry months"
                  type="text"
                  id="LaborSettingExpiryMonths"
                />
              </div>
            </li>
            <li class="accrual_threshold">
              <label for="LaborSettingAccrualThresholdId" class="required">
                Accrual Threshold
              </label>
              <div class="input-wrap select-div">
                <select
                  name="data[LaborSetting][accrual_threshold_id]"
                  class="required"
                  id="LaborSettingAccrualThresholdId"
                >
                  <option value="">Select Accrual Threshold</option>
                  <option value="1">1 week</option>
                  <option value="2">2 week</option>
                  <option value="3">1 month</option>
                  <option value="4">3 month</option>
                  <option value="5">6 month</option>
                </select>
              </div>
            </li>
            <li class="carryover_period">
              <label for="LaborSettingCarryoverPeriodId" class="required">
                Carryover Period
              </label>
              <div class="input-wrap select-div">
                <select
                  name="data[LaborSetting][carryover_period_id]"
                  class="required carryoverPeriodId"
                  id="LaborSettingCarryoverPeriodId"
                >
                  <option value="">Select Carryover Period</option>
                  <option value="1">1 week</option>
                  <option value="2">2 week</option>
                  <option value="3">1 month</option>
                  <option value="4">3 month</option>
                  <option value="5">6 month</option>
                  <option value="6">Never Expires</option>
                  <option value="7">No Carryover</option>
                </select>
              </div>
            </li>
            <li class="max_carryover_days">
              <label for="LaborSettingMaximumCarryoverDays" class="required">
                Maximum Carryover Days
              </label>
              <div class="input-wrap">
                <input
                  name="data[LaborSetting][maximum_carryover_days]"
                  class="required number"
                  type="text"
                  id="LaborSettingMaximumCarryoverDays"
                />
              </div>
            </li>
            <li>
              <label for="LaborSettingAnnualRefreshCycle" class="required">
                Annual Refresh Cycle
              </label>
              <div class="input-wrap select-div">
                <select
                  name="data[LaborSetting][annual_refresh_cycle]"
                  required="required"
                  id="LaborSettingAnnualRefreshCycle"
                >
                  <option value="">Select</option>
                  <option value="1">Start Date Anniversary</option>
                  <option value="2">Calendar Year</option>
                </select>
              </div>
            </li>
            <li>
              <label class="required">
                Additional Allotment Each Full Annual Cycle
              </label>
              <div class="input-wrap select-div">
                <select
                  name="data[LaborSetting][additional_allotment_full_cycle]"
                  class="additionalAllotmentFullCycle required"
                  required="required"
                  id="LaborSettingAdditionalAllotmentFullCycle"
                >
                  <option value="">Select</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
              </div>
            </li>
            <li class="allotment_annual_cycle hide">
              <label>Additional Allotment Amount Each Full Cycle</label>
              <div class="input-wrap">
                <input
                  name="data[LaborSetting][additional_allotment_full_cycle_days]"
                  class="currency_single"
                  type="text"
                  id="LaborSettingAdditionalAllotmentFullCycleDays"
                />
              </div>
            </li>
            <li class="allotment_annual_cycle hide">
              <label>Maximum Allotment Amount</label>
              <div class="input-wrap">
                <input
                  name="data[LaborSetting][max_allotment_amount]"
                  class="currency_single"
                  type="text"
                  id="LaborSettingMaxAllotmentAmount"
                />
              </div>
            </li>
          </ul>
        </fieldset>
      </ModelContainer>

      <ModelContainer
        title={`Add Leave/Claim Rules`}
        open={false}
        closeModal={() => null}
        is_loading={false}
      >
        <fieldset class="">
          <ul class="form-list label-group">
            <li>
              <label for="LaborSettingRuleName" class="required">
                Rule Name
              </label>
              <div class="input-wrap">
                <input
                  name="data[LaborSetting][rule_name]"
                  class="required"
                  placeholder="Rule Name"
                  type="text"
                  id="LaborSettingRuleName"
                />
              </div>
            </li>
            <li>
              <label for="LaborSettingLeaveTypeId" class="required">
                Type
              </label>
              <div class="input-wrap select-div">
                <select
                  name="data[LaborSetting][leave_type_id]"
                  class="required leave_type"
                  id="LaborSettingLeaveTypeId"
                >
                  <option value="">Select Type</option>
                  <option value="1">Annual Leave</option>
                  <option value="2">Sick Leave</option>
                  <option value="3">Compassionate Leave</option>
                  <option value="4">Family Leave</option>
                  <option value="5">Paternity/Maternity Leave</option>
                  <option value="6">Medical Claims</option>
                  <option value="7">Birthday Leave</option>
                  <option value="8">No Pay Leave</option>
                  <option value="9">
                    In-Lieu Leave (Public Holiday with Expiry)
                  </option>
                  <option value="10">
                    In Lieu Leave (Public Holiday Earned)
                  </option>
                  <option value="11">Child Care Leave</option>
                  <option value="12">In Lieu (Year-Round)</option>
                  <option value="13">In Lieu leave (Manual with Expiry)</option>
                  <option value="14">Hospitalisation Leave</option>
                </select>
              </div>
            </li>
            <li>
              <label for="LaborSettingEmploymentStatusId" class="required">
                Employee Status
              </label>
              <div class="input-wrap select-div">
                <select
                  name="data[LaborSetting][employment_status_id]"
                  class="required getEmployees status_dd"
                  id="LaborSettingEmploymentStatusId"
                >
                  <option value="">Select Employment Status</option>
                  <option value="1">Full Time</option>
                  <option value="2">Part Time</option>
                  <option value="3">Contractor</option>
                  <option value="all">All</option>
                </select>
              </div>
            </li>
            <li>
              <label for="LaborSettingEmployeeFunctionId" class="required">
                Employee Function
              </label>
              <div class="input-wrap select-div">
                <select
                  name="data[LaborSetting][employee_function_id]"
                  class="required getEmployees function_dd"
                  id="LaborSettingEmployeeFunctionId"
                >
                  <option value="">Select Employee Function</option>
                  <option value="1">Management</option>
                  <option value="2">Host</option>
                  <option value="3">Kitchen</option>
                  <option value="4">Service</option>
                  <option value="5">Delivery</option>
                  <option value="all">All</option>
                </select>
              </div>
            </li>

            <li>
              <label for="LaborSettingEmployeeCategoryId" class="required">
                Employee Category
              </label>
              <div class="input-wrap select-div">
                <select
                  name="data[LaborSetting][employee_category_id]"
                  class="required getEmployees employee_category_id "
                  id="LaborSettingEmployeeCategoryId"
                >
                  <option value="">Select Employee Category</option>
                  <option value="1">New Category</option>
                  <option value="all">All Categories</option>
                </select>
              </div>
            </li>
            <li class="hide employee_category">
              <label for="LaborSettingEmployeeCategory" class="required">
                Employee Category
              </label>
              <div class="input-wrap">
                <input
                  name="data[LaborSetting][employee_category]"
                  class="required employee_category "
                  type="text"
                  id="LaborSettingEmployeeCategory"
                />
              </div>
            </li>
            <li>
              <label for="LaborSettingEmployeeSelect" class="required">
                Employee Select
              </label>
              <div class="input-wrap select-div">
                <div class="ms-parent">
                  <button type="button" class="ms-choice">
                    <span class="placeholder">Select Employees</span>
                    <div class=""></div>
                  </button>
                </div>
              </div>
            </li>
            <li>
              <label for="LaborSettingAllotmentAmount" class="required">
                Allotment Amount(Days)
              </label>
              <div class="input-wrap">
                <input
                  name="data[LaborSetting][allotment_amount]"
                  class="required number"
                  placeholder="Allotment Amount"
                  step="0.1"
                  autocomplete="off"
                  type="text"
                  id="LaborSettingAllotmentAmount"
                />
              </div>
            </li>
            <li>
              <label for="LaborSettingAccrualTypeId" class="required">
                Accrual Type
              </label>
              <div class="input-wrap select-div">
                <select
                  name="data[LaborSetting][accrual_type_id]"
                  class="required accrual_type"
                  id="LaborSettingAccrualTypeId"
                >
                  <option value="">Select Accrual Type</option>
                </select>
              </div>
            </li>
            <li class="birthexpired">
              <label for="LaborSettingBirthdayExpired" class="required">
                Expired
              </label>
              <div class="input-wrap">
                <input
                  name="data[LaborSetting][birthday_expired]"
                  class="required datepicker"
                  placeholder="Expired"
                  autocomplete="off"
                  type="text"
                  id="LaborSettingBirthdayExpired"
                />
              </div>
            </li>
            <li class="expiry_months">
              <label for="LaborSettingExpiryMonths" class="required">
                Expiry Months
              </label>
              <div class="input-wrap">
                <input
                  name="data[LaborSetting][expiry_months]"
                  class="required number"
                  placeholder="Enter expiry months"
                  type="text"
                  id="LaborSettingExpiryMonths"
                />
              </div>
            </li>
            <li class="accrual_threshold">
              <label for="LaborSettingAccrualThresholdId" class="required">
                Accrual Threshold
              </label>
              <div class="input-wrap select-div">
                <select
                  name="data[LaborSetting][accrual_threshold_id]"
                  class="required"
                  id="LaborSettingAccrualThresholdId"
                >
                  <option value="">Select Accrual Threshold</option>
                  <option value="1">1 week</option>
                  <option value="2">2 week</option>
                  <option value="3">1 month</option>
                  <option value="4">3 month</option>
                  <option value="5">6 month</option>
                </select>
              </div>
            </li>
            <li class="carryover_period">
              <label for="LaborSettingCarryoverPeriodId" class="required">
                Carryover Period
              </label>
              <div class="input-wrap select-div">
                <select
                  name="data[LaborSetting][carryover_period_id]"
                  class="required carryoverPeriodId"
                  id="LaborSettingCarryoverPeriodId"
                >
                  <option value="">Select Carryover Period</option>
                  <option value="1">1 week</option>
                  <option value="2">2 week</option>
                  <option value="3">1 month</option>
                  <option value="4">3 month</option>
                  <option value="5">6 month</option>
                  <option value="6">Never Expires</option>
                  <option value="7">No Carryover</option>
                </select>
              </div>
            </li>
            <li class="max_carryover_days">
              <label for="LaborSettingMaximumCarryoverDays" class="required">
                Maximum Carryover Days
              </label>
              <div class="input-wrap">
                <input
                  name="data[LaborSetting][maximum_carryover_days]"
                  class="required number"
                  type="text"
                  id="LaborSettingMaximumCarryoverDays"
                />
              </div>
            </li>
            <li>
              <label for="LaborSettingAnnualRefreshCycle" class="required">
                Annual Refresh Cycle
              </label>
              <div class="input-wrap select-div">
                <select
                  name="data[LaborSetting][annual_refresh_cycle]"
                  required="required"
                  id="LaborSettingAnnualRefreshCycle"
                >
                  <option value="">Select</option>
                  <option value="1">Start Date Anniversary</option>
                  <option value="2">Calendar Year</option>
                </select>
              </div>
            </li>
            <li>
              <label class="required">
                Additional Allotment Each Full Annual Cycle
              </label>
              <div class="input-wrap select-div">
                <select
                  name="data[LaborSetting][additional_allotment_full_cycle]"
                  class="additionalAllotmentFullCycle required"
                  required="required"
                  id="LaborSettingAdditionalAllotmentFullCycle"
                >
                  <option value="">Select</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
              </div>
            </li>
            <li class="allotment_annual_cycle hide">
              <label>Additional Allotment Amount Each Full Cycle</label>
              <div class="input-wrap">
                <input
                  name="data[LaborSetting][additional_allotment_full_cycle_days]"
                  class="currency_single"
                  type="text"
                  id="LaborSettingAdditionalAllotmentFullCycleDays"
                />
              </div>
            </li>
            <li class="allotment_annual_cycle hide">
              <label>Maximum Allotment Amount</label>
              <div class="input-wrap">
                <input
                  name="data[LaborSetting][max_allotment_amount]"
                  class="currency_single"
                  type="text"
                  id="LaborSettingMaxAllotmentAmount"
                />
              </div>
            </li>
          </ul>
        </fieldset>
      </ModelContainer>
    </UserInterface>
  );
};

export default LaborPolicy;
